export const acceptedMimeTypes = ["image/jpeg", "image/png", "image/jpg"];
export const MAX_IMAGE_SIZE = 3 * 1024 * 1024;
export const ALLOWED_VIDEO_MIME = ["video/mp4", "video/quicktime", "video/webm"];
export const MAX_VIDEO_SIZE = 50 * 1024 * 1024;
export const MAX_VIDEO_DURATION_SEC = 60;
export const DATE_FORMAT = "MM/DD/YYYY";
export const DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm:ss A";
export const DATE_TIME_FORMAT_SHORT = "MM/DD/YYYY hh:mm A";
// [CANA-655] The orders list needs view_order; the room tabs need only
// view_orderroom (the built-in Operators role). View on either opens the
// Orders page (left-menu entry, /admin/orders routes, landing page).
export const ORDERS_VIEW_SUBJECTS = ["order", "orderroom"];
// [CANA-589] each Settings tab reads its own model; view on any of them opens
// the Settings page (left-menu entry and /admin/settings route).
export const SETTINGS_VIEW_SUBJECTS = [
  "setting",
  "tax",
  "integrationsetting",
  "shopsetting",
  "salarysetting",
];
